"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
// import app components
const typography_1 = __importDefault(require("../../elements/typography"));
const avatar_1 = __importDefault(require("../../elements/avatar"));
const paper_1 = __importDefault(require("../../elements/paper"));
const button_1 = __importDefault(require("../../elements/button"));
const table_1 = __importDefault(require("../table"));
const DataTable = (props) => {
    const { tabs, rows, tableHead, onRowClick } = props;
    const [tab, setTab] = (0, react_1.useState)("private");
    const [page, setPage] = (0, react_1.useState)(0);
    const [rowsPerPage, setRowsPerPage] = (0, react_1.useState)(10);
    const handleChangeTab = (e, tab) => {
        setPage(0);
        setTab(tab);
    };
    const handleChangePage = (e, page) => {
        setPage(page);
    };
    const handleChangeRowsPerPage = (e) => {
        setPage(0);
        setRowsPerPage(parseInt(e.target.value, 10));
    };
    const formattedRows = (0, react_1.useMemo)(() => {
        if (!rows)
            return;
        return rows.map((o) => {
            return {
                ...o,
                image: react_1.default.createElement(avatar_1.default, { src: o?.image?.src, size: "medium" }),
                title: o.title,
                onClick: o.slug && onRowClick ? (row) => onRowClick(row) : undefined,
            };
        });
    }, [!!rows, rows?.length]);
    const renderNoDataPlaceholder = () => {
        return (react_1.default.createElement(material_1.Box, { sx: { py: 5 } },
            react_1.default.createElement(material_1.Box, { sx: { textAlign: "center", mb: 5 } },
                react_1.default.createElement(typography_1.default, { variant: "h3", gutterBottom: true }, "No custom data available"),
                react_1.default.createElement(typography_1.default, null, "Contact us to get started with synthetic data")),
            react_1.default.createElement(material_1.Stack, { spacing: 2, direction: "row", sx: { justifyContent: "center" } },
                react_1.default.createElement("a", { href: `${process.env.NEXT_PUBLIC_WEBSITE}/contact-us`, target: "_blank", rel: "noopener noreferrer", style: { textDecoration: "none" } },
                    react_1.default.createElement(button_1.default, { variant: "contained" }, "Contact us")),
                react_1.default.createElement(button_1.default, { variant: "outlined", onClick: () => setTab("public") }, "View Samples"))));
    };
    return (react_1.default.createElement(paper_1.default, null,
        react_1.default.createElement(table_1.default, { page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: [10, 25, 50, 100], head: tableHead, rows: formattedRows?.filter((row) => row.visibility === tab), activeColumns: ["image", "title"], primaryActions: react_1.default.createElement(material_1.Tabs, { value: tab, onChange: handleChangeTab }, tabs.map((tab) => {
                return react_1.default.createElement(material_1.Tab, { key: tab.value, ...tab });
            })), noData: renderNoDataPlaceholder(), defaultOrder: "desc", defaultOrderBy: "date", onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })));
};
exports.default = DataTable;
